"use client";

import ReactPhoneNumberInput, { Country } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import clsx from "clsx";
import { ReactNode } from "react";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "./form";
import { Control } from "react-hook-form";

type Props = {
  label?: ReactNode;
  description?: ReactNode;
  name: string;
  control: Control<any>;
  hideLabel?: boolean;
  className?: string;
  labelClassName?: string;
  defaultCountry?: Country;
};

/**
 * A reusable phone number input component built on top of `react-phone-number-input` with form integration.
 */
export const PhoneInput = ({
  control,
  name,
  label,
  description,
  hideLabel = false,
  className = "",
  labelClassName = "",
  defaultCountry = "GB",
}: Props) => (
  <FormField
    control={control}
    name={name}
    render={({ field, fieldState: { error } }) => (
      <FormItem className={clsx("space-y-1.5", className)}>
        <div>
          <FormLabel
            className={clsx(
              "flex w-full flex-row gap-1 font-sans text-sm font-semibold",
              hideLabel ? "sr-only" : "",
              labelClassName,
            )}
          >
            {label}
          </FormLabel>

          {description && (
            <FormDescription className="mt-0! mb-1!">
              {description}
            </FormDescription>
          )}
        </div>

        <FormControl className="w-full">
          <ReactPhoneNumberInput
            onChange={(value: string | undefined) => field.onChange(value)}
            value={field.value}
            defaultCountry={defaultCountry}
            countryCallingCodeEditable
            focusInputOnCountrySelection
            autoComplete="tel"
            numberInputProps={{
              style: {
                paddingLeft: "12px",
                fontSize: "20px",
              },
            }}
            style={{
              paddingLeft: "12px",
              paddingRight: "2px",
              fontSize: "12px",
              width: "100%",
              borderWidth: "1px",
              borderRadius: "8px",
              lineHeight: "54px",
              backgroundColor: "white",
              fontWeight: 400,
              borderColor: error ? "#ec4899" : "#737373",
            }}
          />
        </FormControl>

        {error?.message && (
          <FormMessage className="font-normal text-pink-500" />
        )}
      </FormItem>
    )}
  />
);
